export function mapPropertyRequired(viewProperty, schemaProperty) {
  if (schemaProperty.use === 'required' || schemaProperty.minItems > 0) {
    return true;
  }
  if (viewProperty.required === 'false') {
    return false;
  }
  return viewProperty.required || false;
}
